import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const OrderContext = createContext()

const OrderProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const getAllOrders = async (currentPage, rowsPerPage, sortField, sortOrder, filter) => {
        try {
            const { data } = await axios.get(`${baseURL}/order/list?&sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&restaurant_id=${restaurantId}&filter=${filter !== '' ? filter : null}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Order', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSingleOrder = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/order/single-order/${id}`, { headers })
            if (data.error === false) {
                return data.order
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Order', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createOrder = async (orderDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/order/create`, orderDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Order', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Order', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Order', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Order', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Order', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateOrder = async (id, orderDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/order/update/${id}`, orderDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Order', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Order', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Order', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Order', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Order', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteOrder = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/order/delete/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Order', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Order', detail: data.message, life: 3000 })
                return data;
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Order', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <OrderContext.Provider value={{ getAllOrders, createOrder, updateOrder, getSingleOrder, deleteOrder }}>
            {children}
        </OrderContext.Provider>
    )
}

const useOrder = () => useContext(OrderContext)

export { useOrder, OrderProvider }